import React, {FC} from 'react';
import returned from '../../assets/images/icon-page/returned.png';


const ReturnedIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'Returned Icon'}) => {
    return (
        <img
            src={returned}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default ReturnedIcon;
